import fontawesome from '@fortawesome/fontawesome'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas, faOtter } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { menuDesktopInit } from './components/menuDesktopScripts';
import { menuMobileInit } from './components/menuMobileScripts';
import { sliderInit } from './components/tinySliderSetting';
import { productVariations } from './components/productVariations';
import { menuProductCard } from './components/menuProductCard';
import { customQuantityFieldsScript } from './components/customQuantityFieldsScript';
import { loginTabs } from './components/loginTabs';
import { getProductsCart } from './components/getProductsCart';
import {blogInit} from './components/blog';



fontawesome.library.add(far, fab, fas)
if(window.innerWidth > 1200 ) {
  menuDesktopInit();
}

menuMobileInit();
sliderInit();
productVariations();
customQuantityFieldsScript();

if(document.querySelector('.section_menu')) {
  menuProductCard();
}


if(document.querySelector('.loginPanel__loginTabsBox')) {
  loginTabs();
}

if(document.querySelector('.section_woocommerce_small_category__wrapper')) {
  getProductsCart();
}

if ( document.querySelector('.section_blog_archive') ) {
  blogInit();
}

jQuery(document).ready(function ( $ ) {
  // smooth scroll to ID
  $('.section_menu__wrapper a[href*="#"]').on('click', function (e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top - 180 // choose what you need
    }, 500, 'linear');
  });
});



//checkout dynamically show company data
const companyCheckbox = document.getElementById("company-expense-checkbox");
if (companyCheckbox) {
  companyCheckbox.addEventListener("click", () => {
    if (companyCheckbox.checked) {
      document.querySelector(".company-data").style.display = "block";
    } else {
      document.querySelector(".company-data").style.display = "none";
    }
  });
}